<template>
  <v-navigation-drawer
    v-model="drawer"
    temporary
    width="500"
    location="right">
    <v-card
      height="100%"
      class="d-flex flex-column"
      title="Feedback"
      variant="flat">
      <v-card-text class="flex-grow-1 overflow-y-auto">
        <div>Please rate the bidding system</div>
        <v-rating
          hover
          :length="5"
          :size="32"
          v-model="rating"
          active-color="var(--c-teal)" />
        <div class="mt-10">
          Add your comments
        </div>
        <v-textarea
          v-model="message"
          :counter="maxChars"
          :rules="[v => (v || '' ).length <= maxChars || `Comments must be ${maxChars} characters or less`]"
          rows="8"
          auto-grow />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <CancelButton
          variant="text"
          data-test="cancel"
          @click="closeDrawer">
          Cancel
        </CancelButton>
        <PrimaryButton
          variant="text"
          @click="submit"
          :loading="isSubmitting"
          :disabled="!valid">
          Submit
        </PrimaryButton>
      </v-card-actions>
    </v-card>
  </v-navigation-drawer>
</template>

<script setup lang="ts">
import { PrimaryButton, CancelButton } from "@/components/buttons";
import { SendUserFeedbackDocument } from "owfsa-graphql";
import { useMutation } from "@urql/vue";
import { isEmpty } from "lodash";
import { computed, ref } from "vue";
import { toast } from "vue-sonner";

const maxChars = 2000;
const sendUserFeedback = useMutation(SendUserFeedbackDocument);

const drawer = defineModel<boolean>({ default: false });
const message = ref();
const rating = ref();
const isSubmitting = ref();

const valid = computed(
  () => !isEmpty(message.value)
    && rating.value
    && message.value.length <= maxChars,
);

const closeDrawer = () => {
  rating.value = null;
  message.value = null;
  drawer.value = false;
};

const submit = async () => {
  isSubmitting.value = true;

  const result = await sendUserFeedback.executeMutation({
    message: message.value,
    rating: rating.value,
  });

  if (!result.error && !!result.data) {
    toast.success("Your feedback has been submitted. Thank you.");
    closeDrawer();
  } else {
    toast.error(
      "An error has occurred while submitting feedback. Please contact your admin.",
    );
  }

  isSubmitting.value = false;
};

</script>
